import ButtonTableAction from '../../../../components/buttons/ButtonTableAction';
import DefaultDataTable from '../../../../components/default/DefaultDataTable';

import { momentParseDate } from '../../../../helpers';

import { formatNumber } from '../../../../utils/utils';
import { TollExpenseDataForm, TollExpenseFilters } from '../../../../app/models/TollExpense';
import TollExpenseFilter from './TollExpenseFilter';
import circleGrey from '../../../../assets/images/icons/circle-color-grey.svg';
import circleRed from '../../../../assets/images/icons/circle-color-red.svg';
import circleGreen from '../../../../assets/images/icons/circle-color-green.svg';
import { useCallback, useContext, useMemo, useState } from 'react';
import { AuthContext } from '../../../../contexts/AuthContext';
import { ExpenseDocumentType } from '../../../../app/models/ExpenseDocumentType';
import { PaymentMethod } from '../../../../app/models/PaymentMethod';
import { AppContext } from '../../../../contexts/AppContext';
import useReactConfirmAlert from '../../../../hooks/useReactConfirmAlert';
import ChangeStatusRows from '../../../../components/ChangeStatusRows';
import {
    MassiveApproveForm,
    defaultMassiveApproveForm,
    tollExApproveOptions
} from '../../../../app/models/Toll';
import { ServiceResponse } from '../../../../app/services/shared/interfaces';
import { StatusRows } from '../../../../app/shared/interfaces';
import useExpenseService from '../../../../app/services/hooks/useExpenseService';
import logo from '../../../../assets/images/logo_pegasus.png';
import LazyLoading from '../../../../components/LazyLoading';
import PreviewImageTable from '../../../../components/PreviewImageTable';

interface Props {
    transportOrderId: number;
    tollExpenses: TollExpenseDataForm[];
    totalRows: number;
    callbackSuccess?: () => void;
    loading?: boolean;
    edit?: (id: number) => void;
    show?: (id: number) => void;
    destroy?: (id: number) => void;
    approved?: (id: number, value: boolean, message: string) => void;
    cancel?: (id: number, value: boolean) => void;
    filter: TollExpenseFilters;
    setFilter: (filter: TollExpenseFilters) => void;
    tollExpensePage?: boolean;
    paginationRowsPerPageOptions?: any[];
    documentTollExpense: (id: number) => void;
    showTollExpenseHistory?: (tollExpenseId: number) => void;
    canBeEdited?: boolean;
    documentTypes: ExpenseDocumentType[];
    paymentMethods: PaymentMethod[];
    onSearch: () => void;

}

const TollExpenseDataTable = ({
    transportOrderId,
    tollExpenses,
    totalRows,
    callbackSuccess,
    loading = false,
    edit,
    destroy,
    approved,
    cancel,
    show,
    filter,
    setFilter,
    documentTollExpense,
    showTollExpenseHistory,
    paymentMethods,
    documentTypes,
    canBeEdited = false,
    onSearch,

}: Props) => {
    const { auth } = useContext(AuthContext);
    const [tollExpenseUrlFile, setTollExpenseUrlFile] = useState<string | undefined>(undefined);

    const columns = [
        {
            name: 'Id',
            selector: (row: any) => row?.expense_id,
            sortable: true,
            sortField: 'expense_id',
            cell: (row: TollExpenseDataForm, index: any, column: any) => (
                <span className="">
                    <img
                        src={
                            row.is_approved == null
                                ? circleGrey
                                : !row.is_approved
                                ? circleRed
                                : circleGreen
                        }
                        alt="circle"
                        style={{
                            width: '25px',
                            height: '25px',
                            marginRight: '5px',
                            marginBottom: '3px'
                        }}
                    />
                    {row.expense_id}
                </span>
            )
        },
        // {
        //     name: 'Orden de transporte',
        //     selector: (row: any) => row?.transport_order_id,
        //     sortable: true,
        //     sortField: 'transport_order_id',
        //                 cell: (row: TollExpenseDataForm, index: any, column: any) => (
        //         <span className="">
        //             {row.transport_order_id ? (

        //                 <Link to={`/tolls/${row.}`}>
        //                     #{row.transport_order_id}
        //                 </Link>

        //             ) : (
        //                 ''
        //             )}
        //         </span>
        //     )
        // },
        {
            name: 'Peaje',
            selector: (row: any) => row?.toll,
            sortable: true,
            sortField: 'toll',
            cell: (row: TollExpenseDataForm, index: any, column: any) => (
                <span
                    className=""
                    dangerouslySetInnerHTML={{ __html: row.toll ? row.toll : '' }}
                ></span>
            )
        },

        {
            name: 'Valor',
            selector: (row: any) => row?.amount,
            sortable: true,
            sortField: 'amount',
            cell: (row: TollExpenseDataForm, index: any, column: any) => (
                <>
                    <span className="">
                        {formatNumber(row.amount ? Number(row.amount) : 0)} {row.currency?.name}
                    </span>
                </>
            )
        },

        {
            name: 'Fecha de emisión',
            selector: (row: any) => row?.issue_date,
            sortable: true,
            sortField: 'issue_date',
            cell: (row: TollExpenseDataForm, index: any, column: any) => (
                <span className="">{momentParseDate(row?.issue_date)}</span>
            )
        },
        {
            name: 'Forma de pago',
            selector: (row: any) => row?.payment_method,
            sortable: true,
            sortField: 'payment_method',
            cell: (row: TollExpenseDataForm, index: any, column: any) => (
                <span className="">{row?.payment_method}</span>
            )
        },
        {
            name: 'Proveedor',
            selector: (row: any) => row?.provider,
            sortable: true,
            sortField: 'provider',
            cell: (row: TollExpenseDataForm, index: any, column: any) => (
                <span
                    className=""
                    dangerouslySetInnerHTML={{ __html: row.provider ? row.provider : '' }}
                ></span>
            )
        },
        {
            name: 'Conductor',
            selector: (row: any) => row?.carrier,
            sortable: true,
            sortField: 'carrier',
            cell: (row: TollExpenseDataForm, index: any, column: any) => (
                <span
                    className=""
                    dangerouslySetInnerHTML={{ __html: row.carrier ? row.carrier : '' }}
                ></span>
            )
        },
        {
            name: 'Acciones',
            selector: (row: any) => row?.id,
            sortable: false,
            width: '150px',
            cell: (row: TollExpenseDataForm, index: any, column: any) => (
                <div className="">
                    {documentTollExpense && (
                        <ButtonTableAction
                            callbackFunction={() => documentTollExpense(row?.id ?? -1)}
                            classIcon={'mdi mdi-download'}
                            colorIcon={row.photo ? 'text-success' : 'text-secondary'}
                            locked={!row.photo}
                            errorMessage={'No se puede descargar este documento.'}
                            title={'Descargar documento'}
                        />
                    )}
                    {show && (
                        <ButtonTableAction
                            callbackFunction={() => show(row?.id ?? -1)}
                            classIcon={'mdi mdi-eye'}
                            colorIcon={'text-info'}
                            errorMessage={'No se puede mostrar este registro.'}
                            title={'Ver'}
                        />
                    )}
                    {edit && (
                        <ButtonTableAction
                            callbackFunction={() => edit(row?.id ?? -1)}
                            classIcon={'mdi mdi-pencil'}
                            colorIcon={'text-warning'}
                            errorMessage={'No se puede editar este registro.'}
                            title={'Editar'}
                        />
                    )}
                    {destroy && (row.is_approved === false || row.is_approved === null) && (
                        <ButtonTableAction
                            callbackFunction={() => destroy(row?.id ?? -1)}
                            classIcon={'mdi mdi-delete'}
                            colorIcon={'text-danger'}
                            errorMessage={'No se puede eliminar este registro.'}
                            title={'Eliminar'}
                        />
                    )}

                    {approved &&
                        (row.is_approved === false || row.is_approved === null) &&
                        auth &&
                        auth?.roles &&
                        !auth?.roles.includes('Conductor') && (
                            <>
                                <ButtonTableAction
                                    callbackFunction={() =>
                                        approved(row?.id ?? -1, true, 'aprobado')
                                    }
                                    classIcon={'mdi mdi-checkbox-marked-circle'}
                                    colorIcon={'text-info'}
                                    errorMessage={'No se puede aprobar este registro.'}
                                    title={'Aprobar'}
                                />
                                <ButtonTableAction
                                    callbackFunction={() =>
                                        approved(row?.id ?? -1, false, 'rechazado')
                                    }
                                    classIcon={'mdi mdi-close-circle'}
                                    colorIcon={'text-danger'}
                                    errorMessage={'No se puede rechazar este registro.'}
                                    title={'Rechazar'}
                                />
                            </>
                        )}
                    {cancel && (row.is_approved === false || row.is_approved === true) && (
                        <ButtonTableAction
                            callbackFunction={() => cancel(row?.id ?? -1, row.is_approved ?? false)}
                            classIcon={'fa fa-ban'}
                            colorIcon={'text-danger'}
                            errorMessage={'No se puede eliminar este anular.'}
                            title={'Anular'}
                        />
                    )}
                    {showTollExpenseHistory &&
                        auth &&
                        auth?.roles &&
                        !auth?.roles.includes('Conductor') && (
                            <ButtonTableAction
                                callbackFunction={() => showTollExpenseHistory(row?.id ?? -1)}
                                classIcon={'mdi mdi-history'}
                                colorIcon={'text-info'}
                                errorMessage={'No se puede mostrar el historial de este registro.'}
                                title={'Mostrar historial'}
                            />
                    )}
                    {/*{showFile && INECESESARIO */}
                    {/*    <ButtonTableAction*/}
                    {/*        callbackFunction={() => showFile(row?.id ?? -1)}*/}
                    {/*        classIcon={'mdi mdi-eye'}*/}
                    {/*        colorIcon={'text-info'}*/}
                    {/*        errorMessage={'No se puede eliminar este anular.'}*/}
                    {/*        title={'Ver documento'}*/}
                    {/*    />*/}
                    {/*}*/}
                </div>
            )
        }
    ];

    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const [rows, setRows] = useState<any[]>([]);
    const [toggleCleared, setToggleCleared] = useState<boolean>(false);
    const [massiveApproveForm, setMassiveApproveFormForm] = useState<MassiveApproveForm>({
        ...defaultMassiveApproveForm,
        transport_order_id: transportOrderId,
        is_toll_expense: true
    });

    const { changeApproveRowsFromTransportOrder, fetchingChangeApproveRowsFromTransportOrder } =
        useExpenseService();

    const contextMessage = ({
        selectedCount,
        allSelected
    }: {
        selectedCount: number;
        allSelected: boolean;
    }) => {
        return {
            singular: 'fila seleccionada',
            plural: 'filas seleccionadas'
        };
    };

    const resetContextActions = () => {
        setToggleCleared(!toggleCleared);
        setRows([]);
        setMassiveApproveFormForm({
            ...massiveApproveForm,
            ...defaultMassiveApproveForm
        });
    };

    const changeApprove = (
        value: string,
        massiveChange: boolean,
        setSelected: (status: string) => void
    ) => {
        if (value === '') {
            setSelected('');
            return;
        }

        const _status = tollExApproveOptions.find((status: StatusRows) => status.value == value);

        const _text = `Está a punto de ${_status?.label} ${
            massiveChange ? 'todos los registros ' : 'los registros marcados'
        } de gastos de peajes`;

        useReactConfirmAlert().requestConfirmation({
            title: '¿Estás seguro?',
            message: _text,
            buttons: {
                confirmButton: {
                    label: 'Si, confirmar',
                    onClick: () => {
                        if (showLoading) showLoading('loading', 'Cambiando estados...');

                        changeApproveRowsFromTransportOrder(
                            {
                                ...massiveApproveForm,
                                approve_status: value,
                                all_selected: massiveChange
                            },
                            {
                                onSuccess: (response: ServiceResponse) => {
                                    if (hideLoading) hideLoading();

                                    useReactConfirmAlert().successAlert({
                                        title: 'Éxito',
                                        message: response.message,
                                        message_list: response.data?.message_list ?? []
                                    });
                                    setSelected(value);
                                    resetContextActions();
                                    if (callbackSuccess) callbackSuccess();
                                },
                                onError: (response: ServiceResponse) => {
                                    if (hideLoading) hideLoading();

                                    useReactConfirmAlert().errorAlert({
                                        title: 'Error',
                                        message: response.message
                                    });
                                }
                            }
                        );
                    }
                },
                cancelButton: {
                    label: 'No, cancelar',
                    onClick: () => {
                        setTimeout(() => {
                            useReactConfirmAlert().infoAlert({
                                title: 'Cancelado',
                                message: 'Los estados de gastos de peaje no se han cambiado.'
                            });
                        }, 0);
                    }
                }
            }
        });
    };

    const contextActions = useMemo(() => {
        return (
            <ChangeStatusRows
                changeStatus={changeApprove}
                className="form-select-sm"
                statuses={tollExApproveOptions}
                default_option={'Seleccione acción'}
            />
        );
    }, [tollExpenses, rows, toggleCleared]);

    const handleRowSelected = useCallback(({ allSelected, selectedCount, selectedRows }: any) => {
        setRows(selectedRows);
        setMassiveApproveFormForm({
            ...massiveApproveForm,
            all_selected: false,
            selected_count: selectedCount,
            rows_ids: selectedRows.map((row: any) => row.id)
        });
    }, []);

    const removeImage = () => {
        setTollExpenseUrlFile(undefined); // Limpiar el estado de la imagen
      
    };

    const rowClick = (row: any) => {
        setTollExpenseUrlFile(row.photo);
    }
    
    const conditionalRowStylesClick = [
       {
          when: (row : any ) => row.photo === tollExpenseUrlFile,  // Condición para resaltar la fila
          style: {
            backgroundColor: '#13395E',  // Estilo de fondo para la fila seleccionada
            color: 'white',
            '&:hover': {
              cursor: 'pointer',
            },
          },
        },
    ];

    return (
        <>
            <div className="row mt-3">
                <div className="col">
                    <TollExpenseFilter
                        filter={filter}
                        setFilter={setFilter}
                        paymentMethods={paymentMethods}
                        documentTypes={documentTypes}
                        onSearch={onSearch}
                    />
                </div>
            </div>

            {canBeEdited && (
                <div className="row mb-2">
                    {/*<div className="col-auto" style={{ paddingTop: 22 }}>*/}
                    {/*    Cambio masivo estado*/}
                    {/*    <ChangeStatusRows*/}
                    {/*        changeStatus={changeApprove}*/}
                    {/*        className="form-select-sm"*/}
                    {/*        statuses={tollExApproveOptions}*/}
                    {/*        default_option={"Seleccione acción"}*/}
                    {/*        massive_change={true}*/}
                    {/*    />*/}
                    {/*</div>*/}
                </div>
            )}
            <div className="row mt-3">

                {
                    tollExpenseUrlFile &&
                    (<PreviewImageTable image={tollExpenseUrlFile} close={removeImage} />)


                }

                <div className={`col-12 col-md-${tollExpenseUrlFile?8:12} order-2 order-md-1`}>
                    <DefaultDataTable
                        title=" "
                        columns={columns}
                        data={tollExpenses}
                        progressPending={loading}
                        paginationTotalRows={totalRows}
                        filter={filter}
                        setFilter={setFilter}
                        isMobileStacked={true}
                        selectableRows={canBeEdited && !auth?.roles?.includes('Conductor')}
                        onSelectedRowsChange={handleRowSelected}
                        selectableRowsHighlight={true}
                        clearSelectedRows={toggleCleared}
                        contextActions={contextActions}
                        resetContextActions={resetContextActions}
                        contextMessage={contextMessage({
                            selectedCount: massiveApproveForm.selected_count ?? 0,
                            allSelected: massiveApproveForm.all_selected!
                        })}
                        onRowClick={rowClick}
                        conditionalRowStyles={conditionalRowStylesClick}
                    />
                </div>

            </div>

        </>
    );
};

export default TollExpenseDataTable;
